module.exports = __webpack_public_path__ + "img/new5.51846227.png";